export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Site"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID Store"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Store Settings"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Payment Link"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Active"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Not Active"])}
}